import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function PendingStudentPopupHW({
  open,
  type,
  onClose,
  onContinue,
}) {
  const cfg = {
    pending: {
      icon: <PendingActionsIcon sx={{ fontSize: 44, color: "#f57c00" }} />,
      title: "Students Pending",
      message:
        "Some students haven’t submitted their homework. Do you still want to publish the result?",
    },
    review: {
      icon: <WarningAmberIcon sx={{ fontSize: 44, color: "#d32f2f" }} />,
      title: "Students Under Review",
      message:
        "Some students’ homework is still under review. Do you want to continue?",
    },
  };

  const c = cfg[type];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: 16, p: 1, width: 480 } }}
    >
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {c.icon}
          <Typography variant="h6" fontWeight={700}>
            {c.title}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ color: "#444", mt: 1 }}>
          {c.message}
        </Typography>
        <Typography
          variant="caption"
          sx={{ display: "block", mt: 2, color: "#777" }}
        >
          You can go back to review student submissions.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{ textTransform: "none", borderRadius: 1, px: 2 }}
        >
          Go Back
        </Button>
        <Button
          variant="contained"
          onClick={onContinue}
          sx={{
            textTransform: "none",
            borderRadius: 1,
            px: 2,
            backgroundColor: "#1976d2",
            "&:hover": { backgroundColor: "#115293" },
          }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}
